/**
 * Custom Link Blocks
 * Handles enhanced interactions for custom link block sections
 */

if (!customElements.get('custom-link-blocks')) {
  class CustomLinkBlocks extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Add any initialization logic here
      this.setupAccessibility();
    }

    setupAccessibility() {
      // Ensure proper keyboard navigation
      const links = this.querySelectorAll('.custom-link-block');
      
      links.forEach(link => {
        // Improve focus management
        link.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            link.click();
          }
        });
      });
    }
  }

  customElements.define('custom-link-blocks', CustomLinkBlocks);
}
